export default "__VITE_ASSET__CBhYvRCj__"